<template>
  <el-table-column
    prop="customer_order.id"
    sortable="custom"
    label="Vevői megrendelés"
    show-overflow-tooltip
    min-width="210"
  >
    <template slot-scope="scope">
      <div
        v-if="scope.row.customer_order && scope.row.customer_order.receipt_number"
        style="display: inline-block;"
      >
        <receipt-link
        v-if="scope.row.customer_order.receipt_number"
        :id="scope.row.customer_order.id"
        :label="scope.row.customer_order.receipt_number"
        type="customerOrder"
        />
      </div>
      <el-tag v-else size="small" type="warning">Nincs kapcsolódó megrendelés</el-tag>
    </template>
  </el-table-column>
</template>

<script>
  import ReceiptLink from '../../../utils/ReceiptLink';

  export default {
    components: {
      ReceiptLink,
    },
    propName: 'customer_order.id',
  };
</script>
